import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { CustomerService } from '../../../services/customer.service';
import { AccountService } from '../../../services/account.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { AccountTypes, gridPageRequest } from '../../../model/common/common.model';

@Component({
  selector: 'app-create-quick-account-group-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './create-quick-account-group-lookup.component.html',
  styleUrl: './create-quick-account-group-lookup.component.scss'
})
export class AccountGroupLookupComponent implements OnInit {
  @Output() AccountGroupId = new EventEmitter<any>();
  constructor(  private accountService:AccountService,private ref: DynamicDialogRef,private messageService: MessageService, private accountServices: AccountService, private customerService: CustomerService) { }

  submitted: boolean = false;
  loader: boolean = false;
  stateList: any[] = [];
  filterStates: any[] = [];
  filteruom: AccountTypes[] = [];
  UOMDropdown: AccountTypes[] = [];
  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 1000,
    id: 0
  }
  accountGroupForm = new FormGroup({
    AccountGroupCode: new FormControl('', Validators.required),
    AccountGroupName: new FormControl('', Validators.required),
    manualEntry: new FormControl(true),
    AccountGroupDescription: new FormControl(),
    ParentGroupId: new FormControl(1),
    isActive: new FormControl(true),
    createdBy: new FormControl(''),
    upatedBy: new FormControl(''),
    accountType: new FormControl('', Validators.required),
    accountTypeId: new FormControl(),
    accountTypeCode: new FormControl()
  });

  ngOnInit(): void {
this.getUOM()
  }

  get formControls() {
    return this.accountGroupForm.controls;
  }

  validateForm() {
    let isValid = true;
    if (this.accountGroupForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' })
      isValid = false;
    }

    return isValid;
  }

  checkAccountGroupCode(): void {
    const accountGroupCode = this.accountGroupForm.controls.AccountGroupCode.value;
    if (!accountGroupCode) {
      return; 
    }
    this.accountServices.checkAccountGroupCode(accountGroupCode).subscribe(
      (data: any) => {
        if (data.success) {
        } else {
          this.accountGroupForm.controls.AccountGroupCode.setValue('');
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: data.message });
          this.accountGroupForm.controls.manualEntry.setValue(true);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }
  
  manualEntry() {
    const manualEntryValue = this.accountGroupForm.controls.manualEntry.value;
    if (manualEntryValue === true) {
      this.accountGroupForm.controls.AccountGroupCode.setValue('');
    } else {
      this.getVendorCode();
    }
  }

  getVendorCode() {
    this.loader = true;
    this.accountServices.autogenerateAccountGroupCode().subscribe({
      next: (data: any) => {
        const alphanumericCode = '';
        const AccountGroupCode = alphanumericCode + data;
        this.accountGroupForm.controls.AccountGroupCode.setValue(AccountGroupCode);
        this.loader = false;
      },
      error: (error: any) => {
        console.log(error);
        this.loader = false;
      }
    });
  }


  filterState(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.stateList as any[]).length; i++) {
      let state = (this.stateList as any[])[i];
      if (state.stateName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(state);
      }
    }

    this.filterStates = filtered;
  }


  // validater() {
  //   const customerCodeControl = this.accountGroupForm.get('vendorCode');
  //   const mobileControl = this.accountGroupForm.get('mobile');
  //   if (mobileControl?.invalid) {
  //     if (mobileControl.errors?.['pattern']) { }
  //     if (mobileControl.errors?.['maxlength']) { }
  //   }
  //   if (customerCodeControl?.invalid) {
  //     if (customerCodeControl.errors?.['required']) {
  //     }
  //     if (customerCodeControl.errors?.['pattern']) {
  //     }
  //   }
  // }

  createAccountGroup(): void {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }

    this.checkAccountGroupCode(); 
  
    const formData = this.accountGroupForm.value;
    if (!formData.ParentGroupId) {
      formData.ParentGroupId = 1;
    }

    const username = localStorage.getItem('username');
    formData.createdBy = username;
    formData.upatedBy = username;

    this.loader = true;

    this.accountServices.createAccountGroup(formData).subscribe({
      next: (data: any) => {
        if (data && typeof data === 'number') {
          console.log('Created Account Group ID:', data);
          this.loader = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: `Account Group created successfully`
          });

          this.AccountGroupId.emit(data);  
          this.ref.close(data);  
        } else {
          this.loader = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Failed',
            detail: 'Failed to create the Account Group.'
          });
        }
      },
      error: (error: any) => {
        console.error('Error creating AccountGroup:', error);
        this.loader = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'An error occurred while creating the account group.'
        });
      }
    });
  }
  
  
  filterUOM(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.UOMDropdown as any[]).length; i++) {
      let uom = (this.UOMDropdown as any[])[i];
      if (uom.accountType.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(uom);
      }
    }
    this.filteruom = filtered;
  }
  setUOM(event: any) { 
    if (event.value) {
      const selectedAccountType = event.value;
      this.accountGroupForm.controls.accountTypeId.setValue(selectedAccountType.accountTypeId);
      this.accountGroupForm.controls.accountType.setValue(selectedAccountType.accountType);
      this.accountGroupForm.controls.accountTypeCode.setValue(selectedAccountType.accountTypeCode);
    }
  }
   
  getUOM(){
    this.accountService.getAllAccountTypes(this.pageRequest).subscribe({
      next: (data:any) => {
        this.UOMDropdown = data.accountType;
      },
      error: (error: any) => {
        console.log(error);
      }
    });
  }
}  